import { memo } from "react"
import Icon from "../Icon"

import './index.scss'
import { COLOR } from "../../data/variables"

type Slot = {
  label: string
  icon?: string
  size?: 'l' | 's'
  color?: 'red' | 'yellow' | 'green'
}

const Slot = memo(({ label, icon, size = 's', color = 'red' }: Slot) => {
  const ICON_COLOR_MAP = {
    'red': COLOR.RED_80,
    'yellow': COLOR.YELLOW_80,
    'green': COLOR.GREEN_50
  }

  return (
    <div className={`Slot size-${size} color-${color}`}>
      {icon && (
        <Icon icon={icon} color={ICON_COLOR_MAP[color]} />
      )}
      {label}
    </div>
  )
})

export default Slot
